export default __webpack_public_path__ + "51ff83d33983e8e0e6e2ffe21ecb05c1.png";